//TODO:  This is probably obsolete.  We should we just use the datasource.service instead.

//add caching support for performance.    Cache codes on client device.   figure out how to know when to refresh code sets.
//Perhaps have background process that refreshes the cache for a code set based on last update date.
//Do we refresh or just delete outdated code sets and have them be downloaded the next time they are needed?
//We need to cache by etm route since code sets could vary accross databases and books
//virtualize some "tables" into CodeSetGet?    Product Line, Subline, etc.   OR have way to "map" a collection into a CodeSetItems object?

import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { share, shareReplay, switchMap, tap } from 'rxjs/operators';
import { AppConfigService } from '@Core/services/proprietary/app-config.service';
import { SessionStorage } from '@Core/services/proprietary/browser-storage/session-storage.service';
import { DatasourceService } from '@Core/services/proprietary/datasource.service';
import { AppService } from './app.service';
import { ErrorService } from './error.service';

@Injectable({ providedIn: 'root' })
export class CodeSetDataService {
    private apiUrl = this.app.AppInfo.SaaS ? this.app.AppInfo.ApiUrl : 'api/etm';
    private readonly sureMgaGuid = 'CE82B2FB-8C32-445C-B70D-EF721DC56185';

    private pending = new Map<string, Observable<any>>();

    constructor(
        private httpClient: HttpClient,
        private data: DatasourceService,
        private appConfig: AppConfigService,
        private errorService: ErrorService,
        private sessionStorage: SessionStorage,
        private app: AppService
    ) { }

    get(setCode: any): Observable<any[]> {
        if (this.cacheHasKey(setCode)) {
            return this.getFromCache(setCode);
        } else {
            return this.getData(setCode);
        }
    }

    getFromCache(setCode) {
        return from(this.cacheGet(setCode)).pipe(switchMap((codeSetData: any[]) => of(codeSetData).pipe(shareReplay(1))));
    }

    intercept(setCode: string, request): Observable<any[]> {
        const pendingRequestObservable = this.pending.get(setCode);
        return pendingRequestObservable ? pendingRequestObservable : this.sendRequest(setCode, request);
    }

    sendRequest(setCode: string, request): Observable<any[]> {
        this.pending.set(setCode, request);
        return request.pipe(
            tap(() => {
                this.pending.delete(setCode);
            })
        );
    }

    getData(setCode: string): Observable<any[]> {
        let queryparms = (this.app.AppInfo.SaaS ? '' : '?Endpoint=') + 'CodeSet/' + encodeURIComponent(setCode);

        if (!this.app.AppInfo.SaaS) {
            if (this.data.ETMSystemOverride.length > 0) {
                queryparms = queryparms + '&system=' + this.data.ETMSystemOverride;
            }
        }

        var headers = new HttpHeaders({
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: 'Sat, 01 Jan 2000 00:00:00 GMT'
        });

        const url = this.apiUrl + queryparms;

        if (this.app.AppInfo.SaaS) {
            headers = headers.append('SureMGAID', this.sureMgaGuid);
            headers = headers.append('Accept', 'application/json');
            headers = headers.append('Ocp-Apim-Subscription-Key', this.app.AppInfo.SubscriptionKey);
        }

        return this.intercept(
            setCode,
            this.httpClient.get(url, { observe: 'response', headers }).pipe(
                switchMap((response) => this.extractData(response, setCode)),
                share()
            )
        );
    }

    private extractData(res: HttpResponse<any>, setCode: string) {
        let body = res.body;
        let isError = this.checkResponse(body);
        let data = [];
        if (!isError) {
            if (body.Content.ConceptOneReply.CodeSetGet.CodeSet?.CodeItems) {
                data = body.Content.ConceptOneReply.CodeSetGet.CodeSet?.CodeItems?.CodeItem || [];
            }

            const dataCacheAllowed = this.appConfig.allowDataCache;
            if (dataCacheAllowed && setCode) {
                this.cacheSave(setCode, data);
            }
        }

        return of(data);
    }

    private checkResponse(responseBody: any) {
        let isError = false;
        const { Process_Status, Process_Message, Reply_Code } = responseBody.Content.ConceptOneReply;
        if (Process_Status == 'ERR') {
            isError = true;
            const codeSetSource: any = {
                _objectType: 'CodeSet',
                _tranType: 'CodeSetGet',
                _httpStatusCode: 200,
                _replyCode: Number(Reply_Code),
                _replyMessage: Process_Message,
                data: responseBody.Content.ConceptOneReply
            };

            const errorData: any = {
                type: 'page',
                message: ''
            };
            this.errorService.showError(errorData, codeSetSource);
        }

        return isError;
    }

    private cacheHasKey(setCode: string) {
        let sig = 'datacache.codeset:' + setCode.toLocaleLowerCase();
        const g2Keys = this.sessionStorage.getAllG2Keys();
        let keyInCache = g2Keys.indexOf(sig) !== -1;
        return keyInCache;
    }

    private async cacheGet(setCode: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            let sig = 'datacache.codeset:' + setCode.toLocaleLowerCase();
            let cachedValue = await this.sessionStorage.getItemAsync(sig);
            if (cachedValue !== null) {
                const parsedValue = JSON.parse(cachedValue);
                resolve(parsedValue);
            } else {
                resolve(null);
            }
        });
    }

    cacheFlushAll() {
        this.sessionStorage.removeItemOfType('codeset');
    }

    async cacheSave(setCode: string, data: any) {
        return new Promise(async (resolve, reject) => {
            if (this.appConfig.allowDataCache) {
                let sig = 'datacache.codeset:' + setCode.toLocaleLowerCase();
                let firstTry = await this.sessionStorage.setItemAsync(sig, JSON.stringify(data));
                if (firstTry) {
                    resolve(true);
                } else {
                    this.cacheFlushAll();
                    let tryAgain = await this.sessionStorage.setItemAsync(sig, JSON.stringify(data));
                    resolve(tryAgain);
                }
            } else {
                resolve(false);
            }
        });
    }
}
